const SVOD = "SVOD"
const FILM_TYPES = ["TVOD", "BUNDLE"]

// Un abonnement ne peut pas être dans le même panier qu'un film (location, achat ou bundle)
// Les produits film ajoutés n'ont pas toujours de type fiable ("Long métrage", undefined...)
// donc on considère comme film tout ce qui n'est ni un abonnement ni un Cinépass
export const isIncompatibleWithCart = (product, cart) => {
	const items = cart && cart.content ? cart.content.items : []

	if (product.type === SVOD) {
		return items.some(item => FILM_TYPES.includes(item.product.type))
	}

	if (product.type === "PREPAYMENT") {
		return false
	}

	return items.some(item => item.product.type === SVOD)
}
